module.exports = __webpack_public_path__ + "static/media/member_cibele.e051c2c6.jpg";